import { render, staticRenderFns } from "./searchResult.vue?vue&type=template&id=fa756f88&scoped=true&"
import script from "./searchResult.vue?vue&type=script&lang=js&"
export * from "./searchResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa756f88",
  null
  
)

export default component.exports